/**
 * Get a value from local storage
 * @param {string} key - Storage key
 * @param {*} defaultValue - Default value if key doesn't exist
 * @returns {*} Retrieved value or default
 */
export const getStorageItem = (key, defaultValue = null) => {
    try {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : defaultValue;
    } catch (error) {
        console.error("Error retrieving data from localStorage:", error);
        return defaultValue;
    }
};

/**
 * Remove a value from local storage
 * @param {string} key - Storage key to remove
 */
export const removeStorageItem = (key) => {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        console.error("Error removing data from localStorage:", error);
    }
};

/**
 * Clear CMS-owned storage without signing out applications mounted on another
 * path of the same origin (for example the DDEV CPO frontend under /cpo).
 */
export const clearCmsStorage = () => {
    try {
        const preservedEntries = Object.keys(localStorage)
            .filter((key) => key.startsWith("cpo:"))
            .map((key) => [key, localStorage.getItem(key)]);

        localStorage.clear();
        preservedEntries.forEach(([key, value]) => {
            if (value !== null) localStorage.setItem(key, value);
        });
    } catch (error) {
        console.error("Error clearing CMS localStorage:", error);
    }
};

/**
 * Update or insert a value in local storage
 * @param {string} key - Storage key
 * @param {Object} newValues - New values to add or update
 */
export const updateStorageItem = (key, newValues) => {
    try {
        const existingData = getStorageItem(key, {});
        const updatedData = { ...existingData, ...newValues };
        localStorage.setItem(key, JSON.stringify(updatedData));
    } catch (error) {
        console.error("Error updating data in localStorage:", error);
    }
};
